import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {AbstractFindAllService} from '../../../../../core/service/v2/service/findAll/abstractFindAll.service';
import {SelectFilterElement} from '../../../../../../components/common/select-filter/select-filter.model';
import {ExamenDefinitionSummaryModel} from '../../entity/examenDefinitionSummary.model';

@Component({
  selector: 'app-exam-form-definition-summary-select-filter',
  templateUrl: './exam-form-definition-summary-select-filter.component.html',
})
export class ExamFormDefinitionSummarySelectFilterComponent {

  @Input() attributeName: 'id' | 'formDefinitionId' | 'formDefinitionName' = 'id';
  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;
  @Input() findAllService: AbstractFindAllService<any, ExamenDefinitionSummaryModel>;

  constructor() {
  }

  filter = (criteria: string, entity: ExamenDefinitionSummaryModel) => {
    return (entity.formDefinition.label).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
  }

  resolveSelectFilterElement = (entity: ExamenDefinitionSummaryModel): SelectFilterElement<number|string, ExamenDefinitionSummaryModel> => {
    let value: number | string = entity.id;
    if (this.attributeName === 'formDefinitionId') {
      value = entity.formDefinition.id;
    } else if (this.attributeName === 'formDefinitionName') {
      value = entity.formDefinition.name;
    }
    return new SelectFilterElement(value, value, entity);
  }

}
